import { MainHeader } from '@/components/main/MainHeader';
import { MainHero } from '@/components/main/MainHero';
import { MainFeatures, MainSellerStart } from '@/components/main/MainFeatures';
import { useMainContent } from '@/components/main/mainContent';
import { SelfLiveBanner } from '@/components/main/SelfLiveBanner';

// LIVEMOA-MAIN-RENEWAL-1 · 대표 검토용 Preview (승인 전까지 기존 "/" 홈은 그대로 유지).
export default function MainRenewal({ user }) {
  const content = useMainContent();
  return (
    <div className="min-h-screen bg-white main-renewal-root" data-testid="main-renewal-page">
      <MainHeader user={user} />
      {content ? <MainHero content={content} /> : (
        <div className="w-full bg-[#5B6BC9] h-[calc(100svh-64px)] md:h-[calc((100svh-80px)*0.8)]" data-testid="main-hero-loading" />
      )}
      <SelfLiveBanner content={content} />
      <MainFeatures content={content} />
      <MainSellerStart user={user} />
    </div>
  );
}
